import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Menu, Tooltip, Empty } from "antd";
import {
  HistoryOutlined,
  FormatPainterOutlined,
  FileTextOutlined,
  EditOutlined,
  EyeOutlined,
  BorderOuterOutlined,
  SettingOutlined,
  InfoCircleOutlined,
  UserOutlined,
  MoneyCollectOutlined,
  TrophyOutlined,
  ShopOutlined,
  ScanOutlined,
  PicRightOutlined,
} from "@ant-design/icons";
import AppIcon from "components/ui/AppIcon";
import AddStoreModel from "features/dashboard/components/AddStoreModel";
import { UTILS } from "utils";
import { PackageUtil } from "utils";
import { API } from "api";
import { useTranslation } from "react-i18next";
import useUserType from "hooks/useUserType";
import useInterval from "use-interval";
import "moment-timezone";
import { CONSTANTS as C } from "config";
import { useGetSettingsMutation } from "redux/settings/settingsSlice";
import { LogoutAction } from "redux/actions";
import { PkgActions } from "redux/actions";
import { Feedback } from "@material-ui/icons";
import { MenuBook } from "@material-ui/icons";
import { StreamRoomsPaths } from "features/byteplus/byteplus.routes";
import { OrderTakingPaths } from "features/order-taking/order-taking.routes";
import { TableManagementPaths } from "features/table-management/routes";
import AppButton from "components/ui/AppButton";

const { SubMenu } = Menu;
const SidebarOptions = ({ setVisible }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [getSettings] = useGetSettingsMutation();
  const { expDays } = useSelector((state) => state.PackagesReducer);
  const [isEnableMenu, setIsEnableMenu] = useState(false);
  const [hasStore, setHasStore] = useState(true);
  const [openAddStoreModal, setOpenAddStoreModal] = useState(false);
  const userType = useUserType();
  const { t } = useTranslation();
  const { isLoggedIn } = useSelector((state) => state.LoginReducer);
  const { integrations } = useSelector((state) => state.SettingsReducer);
  const { currentLanguage } = useSelector((state) => state.LanguageSlice);
  const isByteplusEnabled = useMemo(() => {
    return integrations?.some(
      (integration) =>
        integration?.name === "BYTE_PLUS_LIVE" && integration?.isActive
    );
  }, [integrations]);
  const logout = () => {
    // Notify other tabs about the logout
    localStorage.setItem("logoutEvent", Date.now().toString());
    localStorage.clear();
    UTILS.removeCurrentUser();
    UTILS.removeLanguageInformation();
    window.location.href = "/login";
    dispatch(LogoutAction.logout());
  };
  const check_PackageValidity = async () => {
    const { result } = await UTILS.checkPackageValidity(currentLanguage);
    if (result?.data) {
      const diff = PackageUtil.getPackageExpiry(result.data.subscription);
      dispatch(PkgActions.setDays(diff));
    }
  };
  useEffect(() => {
    check_PackageValidity();
  }, [isLoggedIn]);

  useInterval(() => {
    check_PackageValidity();
  }, C.SIXHOURS);
  let location = useLocation();
  const [current, setCurrent] = useState(
    location.pathname === "/" || location.pathname === ""
      ? "/"
      : location.pathname
  );
  useEffect(() => {
    if (location) {
      if (current !== location.pathname) {
        setCurrent(location.pathname);
      }
    }
  }, [location, current]);

  const getCurrentUserStores = async () => {
    const userDetail = UTILS.getCurrentUser();
    const result = await API.GET_CRRENT_USER_STORES({
      token: userDetail?.token,
      language: "EN",
    });
    if (
      result?.success === 1 &&
      Array.isArray(result?.data) &&
      result?.data?.length > 0
    ) {
      setHasStore(true);
    } else {
      setHasStore(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) getCurrentUserStores();
  }, [isLoggedIn]);

  const isGetStartedRoute = (key) =>
    key === "/app/dashboard/onboarding" || key === "/app/dashboard/get-started";

  const onMenuClick = ({ key, domEvent }) => {
    if (!hasStore && !isGetStartedRoute(key)) {
      domEvent?.preventDefault();
      domEvent?.stopPropagation();
      setOpenAddStoreModal(true);
      return;
    }
    setVisible(false);
    setCurrent(key);
  };

  const openShop = async () => {
    const userDetail = UTILS.getCurrentUser();
    const obj = {
      brandId: userDetail.brandId,
    };
    const data = await getSettings(obj).unwrap();

    if (data?.success === 1 && data?.data?.setting) {
      const userDetail = await UTILS.getCurrentUser();
      let url = `${userDetail.storeFrontURL}${data?.data?.setting?.temporaryDomainName}`;
      window.open(url, "_blank");
    }
  };

  if (expDays <= 5) {
    return (
      <>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        
        <div className="sidebar-scroll min-h-0 flex-1 overflow-y-auto overflow-x-hidden pe-1">
          <Menu
            theme="light"
            className="app-sidebar-menu"
            selectedKeys={[current]}
            defaultSelectedKeys={["/"]}
            mode="vertical"
            onClick={onMenuClick}
          >
            {userType !== C.userTypes?.["STREAM-ROOM-ACCESS"] && (
              <>
                {process.env.REACT_APP_COMPANY_NAME !==
                  C.COMPANY_NAMES.CUSINETTE && (
                  <Menu.Item
                    align="initial"
                    key="/app/dashboard/onboarding"
                    className="rounded-lg "
                    icon={<AppIcon name="rocket" />}
                  >
                    <Link
                      to={"/app/dashboard/onboarding"}
                    >
                      {t("Get Started")}
                    </Link>
                  </Menu.Item>
                )}
                <Menu.Item
                  align="initial"
                  className=""
                  key="/app/dashboard/liveorders"
                  icon={<AppIcon name="tabletWifi" className="text-red-500" />}
                  disabled={isEnableMenu}
                >
                  <Link to={"/app/dashboard/liveorders"}>
                    {t("Live Orders")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key={OrderTakingPaths.takeOrder}
                  align="initial"
                  className=""
                  icon={
                    <AppIcon name="shoppingCart" className="text-red-500" />
                  }
                >
                  <Link to={OrderTakingPaths.takeOrder}>
                    {t("Push Order")}
                  </Link>
                </Menu.Item>
                <SubMenu
                  key="sub1-1"
                  align="initial"
                  title={t("Operations")}
                  icon={<AppIcon name="boundingBox" />}
                  disabled={isEnableMenu}
                >
                  <Menu.Item
                    key="/app/dashboard/inventory"
                    align="initial"
                    icon={<InfoCircleOutlined />}
                    disabled={isEnableMenu}
                  >
                    <Link className="ps-3 ml-0" to={"/app/dashboard/inventory"}>
                      {t("Item Availability")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/app/dashboard/pause-modifier"
                    align="initial"
                    icon={<PicRightOutlined />}
                  >
                    <Link
                      className="ps-3 ml-0"
                      to={"/app/dashboard/pause-modifier"}
                    >
                      {t("Modifier Availability")}
                    </Link>
                  </Menu.Item>
                  <Menu.Item
                    key="/app/dashboard/orderhistory"
                    align="initial"
                    icon={<HistoryOutlined />}
                    disabled={isEnableMenu}
                  >
                    <Link
                      className="ps-3 ml-0"
                      to={"/app/dashboard/orderhistory"}
                    >
                      {t("Order History")}
                    </Link>
                  </Menu.Item>
                </SubMenu>
                <SubMenu
                  key="sub2-2"
                  align="initial"
                  title={t("Marketing")}
                  icon={<AppIcon name="announcement" />}
                  disabled={isEnableMenu}
                >
                  {userType === "BRAND-ADMIN" && (
                    <>
                    <Menu.Item
                        key="/app/dashboard/discount"
                        align="initial"
                        icon={<MoneyCollectOutlined />}
                        disabled={isEnableMenu}
                      >
                        <Link
                          className="ps-3 ml-0"
                          to={"/app/dashboard/discount"}
                        >
                          {t("Discounts")}
                        </Link>
                      </Menu.Item>

                      <Menu.Item
                        key="/app/dashboard/add-update-brand-loyalty"
                        align="initial"
                        icon={<TrophyOutlined />}
                        disabled={isEnableMenu}
                      >
                        <Link
                          className="ps-3 ml-0"
                          to={"/app/dashboard/add-update-brand-loyalty"}
                        >
                          {t("Loyalty")}
                        </Link>
                      </Menu.Item>
                      <Menu.Item
                        key="/app/dashboard/brand-customers"
                        align="initial"
                        icon={<UserOutlined />}
                        disabled={isEnableMenu}
                      >
                        <Link
                          className="ps-3 ml-0"
                          to={"/app/dashboard/brand-customers"}
                        >
                          {t("Customers")}
                        </Link>
                      </Menu.Item>
                    </>
                  )}

                  <Menu.Item
                    key="/app/dashboard/integrations"
                    align="initial"
                    icon={<BorderOuterOutlined />}
                    disabled={isEnableMenu}
                  >
                    <Link
                      className="ps-3 ml-0"
                      to={"/app/dashboard/integrations"}
                    >
                      {t("Integrations")}
                    </Link>
                  </Menu.Item>

                  <Menu.Item
                    key="/app/qr-codes"
                    align="initial"
                    icon={<ScanOutlined />}
                    disabled={isEnableMenu}
                  >
                    <Link className="ps-3 ml-0" to={"/app/qr-codes"}>
                      {t("QR Codes")}
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </>
            )}
            {userType === "BRAND-ADMIN" && (
              <SubMenu
                key="sub3-3"
                align="initial"
                title={t("Products/Menu")}
                icon={<AppIcon name="checkList" />}
                disabled={isEnableMenu}
              >
                <Menu.Item
                  key="/app/dashboard/items"
                  align="initial"
                  icon={<PicRightOutlined />}
                >
                  <Link className="ps-3 ml-0" to={"/app/dashboard/items"}>
                    {t("Items")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/modifiers-list"
                  align="initial"
                  icon={<PicRightOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to="/app/dashboard/modifiers-list"
                  >
                    {t("Modifiers")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/modifier-group"
                  align="initial"
                  icon={<PicRightOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to="/app/dashboard/modifier-group"
                  >
                    {t("Modifier Groups")}
                  </Link>
                </Menu.Item>

                <Menu.Item
                  key="/app/dashboard/menu-list"
                  align="initial"
                  icon={<MenuBook />}
                >
                  <Link className="ps-3 ml-0" to="/app/dashboard/menu-list">
                    {t("Menus")}
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}
            {userType === "BRAND-ADMIN" && (
              <SubMenu
                key="sub4-4"
                align="initial"
                title={t("Reports")}
                icon={<AppIcon name="file01" />}
                disabled={isEnableMenu}
              >
                <Menu.Item
                  key="/app/dashboard/reporting/orders"
                  align="initial"
                  icon={<FileTextOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to={"/app/dashboard/reporting/orders"}
                  >
                    {t("Order History")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/reporting/customers"
                  align="initial"
                  icon={<EditOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to={"/app/dashboard/reporting/customers"}
                  >
                    {t("Customer Report")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/reporting/payments"
                  align="initial"
                  icon={<EditOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to={"/app/dashboard/reporting/payments"}
                  >
                    {t("Payment Links History")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/reporting/user-feedbacks"
                  align="initial"
                  icon={<Feedback />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to="/app/dashboard/reporting/user-feedbacks"
                  >
                    {t("Order Feedbacks")}
                  </Link>
                </Menu.Item>
              </SubMenu>
            )}

            {userType !== C.userTypes?.["STREAM-ROOM-ACCESS"] && (
              <>
                <Menu.Item
                  align="initial"
                  key="/app/dashboard"
                  icon={<AppIcon name="dashboardBrowsing" />}
                >
                  <Link to={"/app/dashboard"}>
                    {t("Dashboard")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  key="/app/dashboard/shipping"
                  align="initial"
                  icon={<AppIcon name="truckDelivery" />}
                  disabled={isEnableMenu}
                >
                  <Link to={"/app/dashboard/shipping"}>
                    {t("Shipping & Delivery")}
                  </Link>
                </Menu.Item>

                <Menu.Item
                  key="/app/dashboard/payment-links"
                  align="initial"
                  icon={<AppIcon name="copyLink" />}
                  disabled={isEnableMenu}
                >
                  <Link to="/app/dashboard/payment-links">
                    {t("Payment Links")}
                  </Link>
                </Menu.Item>
              </>
            )}
            {/* Byteplus live stream rooms start*/}
            <Menu.Item
              key={StreamRoomsPaths.list}
              align="initial"
              icon={<AppIcon name="frame" />}
              disabled={!isByteplusEnabled}
            >
              <Tooltip
                title={
                  !isByteplusEnabled &&
                  t("Stream Rooms are not enabled, please contact support team")
                }
              >
                {isByteplusEnabled ? (
                  <Link
                    disabled={!isByteplusEnabled}
                    to={StreamRoomsPaths?.list}
                  >
                    {t("Stream Rooms")}
                  </Link>
                ) : (
                  <span className="ps-3 ml-0">{t("Stream Rooms")}</span>
                )}
              </Tooltip>
            </Menu.Item>
            {/* Byteplus live stream rooms end*/}
            {/* table management start*/}
            <Menu.Item
              key={TableManagementPaths.tableManagement}
              align="initial"
              icon={<AppIcon name="tableManagement" />}
            >
              <Link
                to={TableManagementPaths.tableManagement}
              >
                {t("Table Management")}
              </Link>
            </Menu.Item>
            {/* table management end*/}
          </Menu>
        </div>
        <div className="sticky bottom-0 z-10 shrink-0 bg-white pt-2">
          <Menu
            className="app-sidebar-menu"
            selectedKeys={[current]}
            defaultSelectedKeys={["/"]}
            mode="vertical"
            onClick={onMenuClick}
          >
            <SubMenu
              key="sub6-6"
              align="initial"
              title={t("Settings")}
              icon={<AppIcon name="setting01" />}
              disabled={isEnableMenu}
            >
              {userType === C.USER_TYPE_ADMIN && (
                <Menu.Item
                  key="/app/Ordering/page"
                  align="initial"
                  icon={<EyeOutlined />}
                >
                  <span onClick={openShop} className="ps-3 ml-0 cursor-pointer">
                    {t("View Ordering Page")}
                  </span>
                </Menu.Item>
              )}
              {userType === C.USER_TYPE_ADMIN && (
                <Menu.Item
                  key="/app/dashboard/stores"
                  align="initial"
                  icon={<ShopOutlined />}
                  disabled={isEnableMenu}
                >
                  <Link className="ps-3 ml-0" to={"/app/dashboard/stores"}>
                    {t("Stores")}
                  </Link>
                </Menu.Item>
              )}
              {userType === C.USER_TYPE_ADMIN && (
                <Menu.Item
                  key="/app/dashboard/settings/branding"
                  align="initial"
                  icon={<FormatPainterOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to={"/app/dashboard/settings/branding"}
                  >
                    {t("Branding")}
                  </Link>
                </Menu.Item>
              )}
              {userType === C.USER_TYPE_ADMIN && (
                <Menu.Item
                  key="/app/dashboard/settings/business"
                  align="initial"
                  icon={<SettingOutlined />}
                >
                  <Link
                    className="ps-3 ml-0"
                    to={"/app/dashboard/settings/business"}
                  >
                    {t("Business settings")}
                  </Link>
                </Menu.Item>
              )}

              <Menu.Item
                key="/app/dashboard/settings/profile"
                align="initial"
                icon={<UserOutlined />}
              >
                <Link
                  className="ps-3 ml-0"
                  to={"/app/dashboard/settings/profile"}
                >
                  {t("My Profile")}
                </Link>
              </Menu.Item>
            </SubMenu>

            {userType === "BRAND-ADMIN" ? (
              <Menu.Item
                key="/app/dashboard/userroles"
                align="initial"
                icon={<AppIcon name="user1" />}
                disabled={isEnableMenu}
              >
                <Link to={"/app/dashboard/userroles"}>
                  {t("User Roles")}
                </Link>
              </Menu.Item>
            ) : null}

            {/* {process.env.REACT_APP_COMPANY_NAME !==
              C.COMPANY_NAMES.CUSINETTE && (
              <Menu.Item
                key="/app/dashboard/help"
                align="initial"
                icon={<AliwangwangOutlined />}
              >
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://wa.me/971527325000?text=How can we help?"
                  className="ps-3 ml-0"
                >
                  {t("Need help")}
                </a>
              </Menu.Item>
            )} */}
            {/* <Menu.Item
              key="/app/dashboard/logout"
              align="initial"
              icon={<LogoutOutlined />}
              onClick={() => logout()}
            >
              <span className="ps-3">{t("Logout")}</span>
            </Menu.Item> */}
          </Menu>
        </div>
      </div>
      <AddStoreModel
          open={openAddStoreModal}
          onClose={() => {
            setOpenAddStoreModal(false);
            history.push("/app/dashboard/onboarding");
          }}
        />
        </>
    );
  }
  return <Empty description={t("Subscription expired, please contact support team")}>
    <AppButton variant="primary" onClick={() => {
      window.open("https://wa.me/971527325000?text=How%20can%20we%20help?", "_blank");
    }}>
      {t("Contact Support")}
    </AppButton>
  </Empty>
};
export default SidebarOptions;
